export default {
	Card: 1, // Card Not Present (i.e. Online or MOTO)
	Cash: 2,
	Voucher: 3,
	CreditNote: 4,
	None: 5,
	Cheque: 6,
	Bacs: 7,
	CardHolderPresent: 8,
	Placeholder: 9
};
